import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import { IPostPayment } from 'data/entities/post-payment';
import { capitalize } from 'lodash';
import React, { useState } from 'react';
import { fromFloyd } from '../../../../entities/pricing/helpers';

export interface IHistoricalPaymentComponentProps {
	postPayments: IPostPayment[];
	deletePostPayments: (postPayments: IPostPayment[]) => void;
}

const formatDateTime = (date: Date) => date.toLocaleString('en-us', {});
const getDirectionEmoji = (direction: string) => direction === 'debit' ? '💰' : '💸';

export const HistoricalPaymentComponent: React.FunctionComponent<IHistoricalPaymentComponentProps> = (props) => {
	const [expanded, setExpanded] = useState(false);
	const toggleExpanded = () => setExpanded(!expanded);

	const firstPayment = props.postPayments[0];
	const reason = firstPayment.reason;
	const date = new Date(firstPayment.created_at || '');

	const classList = [
		'historical-payment__container',
		...(expanded ? ['historical-payment__container--expanded'] : ['historical-payment__container--minimised'])
	];

	return <div className={classList.join(' ')} onClick={(event) => toggleExpanded()}>
		<div className="historical-payment__summary">
			<section className="historical-payment__column">
				<span>{date.toDateString()}</span>
			</section>
			<section className="historical-payment__column">
				<span>{reason}</span>
			</section>
		</div>
		{expanded ? <>
			<hr className="historical-payment__separator" />
			<ul className="historical-payment__list">
				{props.postPayments.map((payment) => <li>
					<span>
						<span aria-hidden="true">{getDirectionEmoji(payment.direction)} </span>
						{`${capitalize(payment.target)}
						${payment.direction === 'debit' ? 'charge' : 'payment'} for ${fromFloyd(payment.amount).toFixed(2)} ${payment.currency} ${payment.taxable ? '+ VAT (if applicable)' : ''} was
						issued on ${formatDateTime(new Date(payment.created_at || ''))}`}
					</span>

					<Button
						bgColor={theme.colours.error.default}
						color={theme.colours.text.lightest}
						hoverColor={theme.colours.error.misc}
						onClick={(event) => {
							event.stopPropagation();
							props.deletePostPayments([payment]);
						}}>Delete</Button>
				</li>)}
			</ul>
		</> : ''}
	</div>;
};
